const KEY = 'talk.speaker'

export function loadSpeaker(): boolean {
  try {
    const raw = localStorage.getItem(KEY)
    if (raw === null) return true
    return raw !== '0'
  } catch {
    return true
  }
}

export function saveSpeaker(on: boolean): void {
  try {
    localStorage.setItem(KEY, on ? '1' : '0')
  } catch {
    /* ignore */
  }
}
